
export function setTrustedHTML(element, html) {
  const template = document.createElement('template');
  template.innerHTML = html;
  element.replaceChildren(template.content);
}

export function replaceChildrenFrom(target, source) {
  target.replaceChildren(...source.cloneNode(true).childNodes);
}

export function createFocusTrap(element) {
  const focusableSelectors = [
    'button:not([disabled]):not([tabindex="-1"])',
    '[href]:not([tabindex="-1"])',
    'input:not([disabled]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(', ');

  let focusableElements = [];
  let firstElement = null;
  let lastElement = null;

  function updateFocusableElements() {
    focusableElements = [...element.querySelectorAll(focusableSelectors)];
    firstElement = focusableElements[0];
    lastElement = focusableElements[focusableElements.length - 1];
  }

  function handleKeydown(e) {
    if (e.key !== 'Tab') return;

    updateFocusableElements();
    if (!focusableElements.length) return;

    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }

  element.addEventListener('keydown', handleKeydown);

  
  updateFocusableElements();
  if (firstElement) {
    requestAnimationFrame(() => firstElement.focus());
  }

  return {
    update: updateFocusableElements,
    destroy() {
      element.removeEventListener('keydown', handleKeydown);
    },
  };
}

export default { setTrustedHTML, replaceChildrenFrom, createFocusTrap };
